export const SUMMARY_STEP_ROUTE = 'podsumowanie';
export const SUMMARY_STEP_PARAMETRIZED_ROUTE = ':id/podsumowanie';
